module.exports = __webpack_public_path__ + "img/postpartum.49e54776.png";